"use client"

import {ChevronsUpDown, LogOut,} from "lucide-react"

import {Avatar, AvatarFallback, AvatarImage,} from "@/components/ui/avatar"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar,} from "@/components/ui/sidebar"
import {getUserProfile, logout} from "@/app/auth/authService";
import React from "react";

// Fonction utilitaire pour obtenir les initiales
const getInitials = (name: string): string => {
    if (!name) return "?"; // Cas où le nom est vide ou non fourni

    const words = name.split(' ').filter(Boolean); // Sépare par espace et retire les vides

    if (words.length === 0) return "?";

    if (words.length === 1) {
        // Si un seul mot, prend les 1 ou 2 premières lettres
        return words[0].substring(0, 2).toUpperCase();
    } else {
        // Si plusieurs mots, prend la première lettre du premier et du dernier mot
        return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    }
};

export function NavUser() {
    const {isMobile} = useSidebar()

    const [user, setUser] = React.useState(null);

    React.useEffect(() => {
        getUserProfile()
            .then((authenticatedUser) => {
                console.log("Got user:");
                console.log(authenticatedUser);
                return setUser(authenticatedUser || false);
            });
    }, []);

    if (user === null) return <SidebarMenu/>;

    const userInitials = getInitials(user?.name); // Ajouter '?' pour la sécurité si user peut être null

    return (
        <SidebarMenu>
            <SidebarMenuItem>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <SidebarMenuButton
                            size="lg"
                            className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
                        >
                            <Avatar className="h-8 w-8 rounded-lg">
                                <AvatarImage src={user.avatar} alt={user.name} />
                                <AvatarFallback className="rounded-lg bg-muted text-muted-foreground">
                                    {userInitials}
                                </AvatarFallback>
                            </Avatar>
                            <div className="grid flex-1 text-left text-sm leading-tight">
                                <span className="truncate font-semibold">{user.name}</span>
                                <span className="truncate text-xs">{user.email}</span>
                            </div>
                            <ChevronsUpDown className="ml-auto size-4" />
                        </SidebarMenuButton>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
                        side={isMobile ? "bottom" : "right"}
                        align="end"
                        sideOffset={4}
                    >
                        <DropdownMenuLabel className="p-0 font-normal">
                            <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                                <Avatar className="h-8 w-8 rounded-lg">
                                    <AvatarImage src={user.avatar} alt={user.name} />
                                    <AvatarFallback className="rounded-lg">{userInitials}</AvatarFallback>
                                </Avatar>
                                <div className="grid flex-1 text-left text-sm leading-tight">
                                    <span className="truncate font-semibold">{user.name}</span>
                                    <span className="truncate text-xs">{user.email}</span>
                                </div>
                            </div>
                        </DropdownMenuLabel>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem onClick={() => {logout()}}>
                            <LogOut size={16} />
                            Log out
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </SidebarMenuItem>
        </SidebarMenu>
    )
}
